import styles from './contact.module.scss'

import React from 'react'

import { createClickedSegmentEvent } from 'Clutch/Utilities/Instrumentation/Impressions/impressionSegmentEvents'

import ContactUsCard from 'Clutch/Organisms/ContactUsCard/ContactUsCard'

import Button from 'Clutch/Molecules/Button'

import Card from 'Clutch/Atoms/Card'
import Svg from 'Clutch/Atoms/Svg'
import Typography from 'Clutch/Atoms/Typography'

const Contact = ({}) => {
  return (
    <div className={styles.contact_card}>
      <ContactUsCard />
    </div>
  )
}

export default Contact
